import { ENDPOINT } from '~/constants';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { zodCompanyAliasAddressSchema } from '../validations';

import {
  type CreateCompanyAliasAddressPayload,
  type CreateCompanyAliasAddressResponse,
} from './types';
import { zodCreateCompanyAliasAddressPayloadSchema } from './validations';

/**
 * Creates a company alias address.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company-Alias-Addresses/operation/create_company_address_vadmin_company_alias_address_post
 */
export const createCompanyAliasAddress = async (
  payload: CreateCompanyAliasAddressPayload,
) => {
  try {
    return await vestigasApi
      .post(ENDPOINT.COMPANY.ALIAS_ADDRESS.CREATE(), {
        json: payload,
        validate: {
          body: zodCreateCompanyAliasAddressPayloadSchema,
          response: zodCompanyAliasAddressSchema,
        },
      })
      .json<CreateCompanyAliasAddressResponse>();
  } catch (error) {
    log.error({
      message: 'Error creating company alias address',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(
            ($) => $.company.createCompanyAliasAddress.error422,
            {
              ns: 'data',
            },
          );
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.company.createCompanyAliasAddress.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
